<template>
  <div class="container">
    <el-menu
      :default-active="activeIndex2"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b">
      <el-menu-item index="1">泵状态数据</el-menu-item>
      <el-menu-item index="2">传感器状态数据</el-menu-item>
      <el-menu-item index="3">基础量数据</el-menu-item>
      <el-menu-item index="4">血糖数据</el-menu-item>
    </el-menu>
    <div class="modeln">
        <BasicQuantity v-show="aType =='3'"></BasicQuantity>
    </div>
  </div>
</template>

<script>
import BasicQuantity from './DevDebugData/BasicQuantity.vue'
export default {
    components:{
        BasicQuantity
    },
    data() {
      return {
        aType:'3',
        activeIndex2: '3'
      }
    },
    methods:{
      handleSelect(key, keyPath) {
        this.aType =key
      }
    }
}
</script>

<style scoped>
  .container {
    height:100%;
    background-color:#ffffff;
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  .el-menu-demo {
    width: 100%;
    padding-top: 20px;
    display: flex;
    justify-content: center;
  }
  .modeln {
    margin-top: 20px;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// BasicQuantityRecord.vue?9bc95c3e